import request from '@/utils/request'
import md5 from 'js-md5'

/**
 * 生成优惠券接口专用签名
 * 规则：sign = MD5(requestId + timestamp + dg.md5Key).toUpperCase()
 */
export function generateCouponSign(requestId, timestamp, md5Key) {
  return md5(requestId + timestamp + md5Key).toUpperCase()
}

/**
 * 生成优惠券接口专用的 requestId
 * 格式示例：PCD20260427170500001
 */
export function generateCouponRequestId() {
  var date = new Date()
  var year = date.getFullYear()
  var month = String(date.getMonth() + 1).padStart(2, '0')
  var day = String(date.getDate()).padStart(2, '0')
  var hour = String(date.getHours()).padStart(2, '0')
  var min = String(date.getMinutes()).padStart(2, '0')
  var randomStr = String(Math.floor(Math.random() * 100000)).padStart(5, '0')
  return 'PCD' + year + month + day + hour + min + randomStr
}

/**
 * 领取优惠券接口
 * @param {string} mobile - 手机号
 */
export function dispatchCoupon(mobile) {
  var timestamp = String(Date.now())
  var requestId = generateCouponRequestId()
  
  // 从环境变量读取配置
  var md5Key = process.env.VUE_APP_MD5_KEY
  var productCode = process.env.VUE_APP_PRODUCT_CODE
  
  var sign = generateCouponSign(requestId, timestamp, md5Key)

  return request({
    url: '/petroChinaCouponDispatch/dispatch',
    method: 'post',
    data: {
      requestId: requestId,
      timestamp: timestamp,
      sign: sign,
      mobile: mobile,
      productCode: productCode
    }
  })
}
